import styled from "styled-components";

const Cover = styled.img`
  width: 100%;
  height: auto;
  margin-top: 50px;
  /* &:before {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: block;
    left: 0;
    top: 0;
    content: "";
    background: rgba(0, 0, 0, 0.4);
  } */
`;

export default Cover;
